import apiClient from './index';

const getPricePath = ({articleType}) => {
  return `article-orders/price/${articleType}/`
}

export default {
  async getProductPrice(urlParams, data) {
    return await apiClient.post(getPricePath(urlParams), data)
  },
}
